import ConnectSection, { connectTitle, firstName } from "./ConnectSection";

export { connectTitle, firstName };
export default ConnectSection;
